import React from 'react';
import queryString from 'query-string';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import Box from '@material-ui/core/Box';
import every from 'lodash/every';
import partial from 'lodash/partial';
import has from 'lodash/has';
import Loading from 'components/Loading';
import Header from 'components/Header';
import useCurrentUser from 'hooks/useCurrentUser';
import EmailVerifiedPaper from './EmailVerifiedPaper';

// https://reacttraining.com/react-router/web/example/auth-workflow
interface PrivateRouteProps {
  component?:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
}
const PrivateRoute: React.FC<PrivateRouteProps & RouteProps> = ({
  component: Component,
  ...rest
}) => {
  const { currentUser, loading, error, auth } = useCurrentUser();

  const hasSignupRequireInfo =
    !loading &&
    !error &&
    currentUser &&
    every(
      ['phone', 'email', 'first_name', 'last_name', 'profile.username'],
      partial(has, currentUser)
    );
  const emailVerified = auth && auth.emailVerified;

  return (
    <Route
      {...rest}
      render={props => {
        if (loading) return <Loading />;
        if (!currentUser) {
          return (
            <Redirect
              to={{
                pathname: '/signin',
                search: `?${queryString.stringify({
                  redirect: props.location.pathname
                })}`
              }}
            />
          );
        }
        if (!hasSignupRequireInfo) {
          return (
            <Redirect
              to={{
                pathname: '/signup',
                search: `?${queryString.stringify({
                  extraInfo: true,
                  redirect: props.location.pathname
                })}`
              }}
            />
          );
        }
        if (!emailVerified) {
          return (
            <>
              <Header />
              <Box mt={5}>
                <EmailVerifiedPaper />
              </Box>
            </>
          );
        }
        // @ts-ignore
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
